import React, { Component } from 'react'
import {
    MDBContainer,
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    MDBIcon,
    MDBRow, MDBCol, MDBBadge
  } from 'mdbreact';
  import { api } from '../../api';
  import Swal from 'sweetalert2'

export default class Modaleditstatus2 extends Component {
    constructor(props) {
        super(props);
this.state = {
    modal: false,
    id_room:'',//ห้องที่ต้องการเปลี่ยน
    numberroom:'',//เลขห้องที่ต้องการเปลี่ยน
    move: false,
    room:[],
    roomset:'',//เลขห้องที่จะเปลี่ยน
    numberroomset:'',//ห้องห้องที่จะเปลี่ยน

    //timecheck
    id_time: "",
    Depositkey: "", //มัดจำกุญแจ
    Differences: "",
    pic_idcard: "",
    price: "",
    roommove: "",
    status: "1",
    status_Depositkey: "",
    sumprice: "",
    tel: "",
    temporary: "",
    timeend: "",
    timestart: "",

    //report
    Depositkey1: "", //มัดจำกุญแจ
    endtimereport: "",
    id_memberreport: "",
    id_reportlist: "",
    numberroommove: "",
    starttimereport: "",
    status1: "1",
    status_Depositkey1: "",
    sumpricereport: "",
    tel1: "",

    detel:'',



}

 this.updatestatusopenroom = this.updatestatusopenroom.bind(this);
 this.updatestatusmoveroom = this.updatestatusmoveroom.bind(this);
 this.updatemoveroom = this.updatemoveroom.bind(this);
 this.getroom = this.getroom.bind(this);
 this.handleChange = this.handleChange.bind(this);
 this.gettimecheck = this.gettimecheck.bind(this);
 this.getreportlist = this.getreportlist.bind(this);
 this.onTextChange = this.onTextChange.bind(this);
 this.updatescontinueroom = this.updatescontinueroom.bind(this);
// this.toggle = this.toggle.bind(this);
// this.handleChange4 = this.handleChange4.bind(this);
this.updateDepositkey = this.updateDepositkey.bind(this);
}

onTextChange = (e) => {
  this.setState({ [e.target.name]: e.target.value })
}

toggle = () => {
    this.setState({
      modal: !this.state.modal,
      id_room: this.props.id_room,//ห้องที่ต้องการเปลี่ยน
      numberroom: this.props.numberroom//เลขห้องที่ต้องการเปลี่ยน


    });
    this.getroom();
    this.gettimecheck();
    this.getreportlist();
  }

  updatemoveroom = () => {
    this.setState({
      move: !this.state.move,
     
    });
  }

  getroom (){
   // this.setState({ loading:true})
      api.get('lkselectroom.php')
      .then(res => {
      //  console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ room: res.data})
      }) 
  }

  gettimecheck (){
    // this.setState({ loading:true})
       api.get('lkselectroomidtimeend.php?roomid='+this.props.id_room)
       .then(res => {
         console.log(res.data);

        
        this.setState({ 
            id_time: res.data[0].id_time,
            pic_idcard: res.data[0].pic_idcard,
            timestart: res.data[0].timestart,
            timeend: res.data[0].timeend,
            price: res.data[0].price,
            Differences: res.data[0].Differences,
            sumprice: res.data[0].sumprice,
            temporary: res.data[0].temporary,
            Depositkey: res.data[0].Depositkey,
            status_Depositkey: res.data[0].status_Depositkey,  
            tel: res.data[0].tel,
            status: res.data[0].status,
          
          
        })
        // this.setState({ room: res.data})
       }) 
   }

   getreportlist (){
    // this.setState({ loading:true})
       api.get('lkselectroomreportid.php?roomid='+this.props.id_room)
       .then(res => {
       //  console.log(res);
       //  this.setState({ bankname: res.data, loading: false })
         this.setState({ 
            Depositkey1: res.data[0].Depositkey,
            endtimereport: res.data[0].endtimereport,
            id_memberreport: res.data[0].id_memberreport,
            id_reportlist: res.data[0].id_reportlist,
            numberroommove: res.data[0].numberroommove,
            starttimereport: res.data[0].starttimereport,
            status1: res.data[0].status,
            status_Depositkey1: res.data[0].status_Depositkey,
            sumpricereport: res.data[0].sumpricereport,
            tel1: res.data[0].tel,
         })
       }) 
   }

  handleChange(event) {  
   
         const idd = event.target.value;

         const filtered2 = this.state.room.filter(room => {
            return room.id_room === idd;
          });
          console.log(filtered2[0].id_room);
          this.setState({
                     roomset:filtered2[0].id_room,
                     numberroomset:filtered2[0].numberroom
                 })

    //  this.setState({roomset: event.target.value}); 
//       api.get('lkselectroomid.php?id_room='+idd)
//       .then(res => {
    
//       this.setState({
//         roomset:res.data[0].id_room,
//         numberroomset:res[0].data.numberroom 
//     })

//   console.log(res.data[0].id_rid_roomoom,);
//       }) 


  
     }

  updatestatusopenroom (){
           
    setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id", this.state.id_room);
   

      api.post("lkupdatestatusroom.php",datafrm,{
       headers: {
                 'content-type': 'multipart/form-data'
                }
                })
                        .then(res => {
                           // console.warn(res);
                           // console.log("response: ", res)
                            if (res.status=== 200) {

                          Swal.fire({
                            title: 'เปิดห้องสำเร็จ',
                            icon: 'success',
                          // showCancelButton: true,
                            confirmButtonText: 'ตกลง',
                          // cancelButtonText: 'No, keep it'
                          }).then((result) => {
                            this.props.getroom();
                            this.toggle();
                           // this.getwork();
                           // window.location.href = '/'
                          })

                            }else{
                            // window.location.href = '/'
                            }

                        })

            }, 1000);

  }

  updatestatusmoveroom (){
           
    setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id", this.state.id_room);//
      datafrm.append("numberroom", this.state.numberroom);
    
      datafrm.append("Depositkey", this.state.Depositkey);
      datafrm.append("Differences", this.state.Differences);
      datafrm.append("pic_idcard", this.state.pic_idcard);
      datafrm.append("price", this.state.price);
      datafrm.append("roommove", this.state.roommove);
      datafrm.append("status", this.state.status);
      datafrm.append("status_Depositkey", this.state.status_Depositkey);
      datafrm.append("sumprice", this.state.sumprice);
      datafrm.append("tel", this.state.tel);
      datafrm.append("temporary", this.state.temporary);
      datafrm.append("timeend", this.state.timeend);
      datafrm.append("timestart", this.state.timestart);

      datafrm.append("Depositkey1", this.state.Depositkey1);
      datafrm.append("endtimereport", this.state.endtimereport);
      datafrm.append("id_memberreport", this.state.id_memberreport);
      datafrm.append("id_reportlist", this.state.id_reportlist);
      datafrm.append("numberroommove", this.state.numberroommove);
      datafrm.append("starttimereport", this.state.starttimereport);
      datafrm.append("status1", this.state.status1);
      datafrm.append("status_Depositkey1", this.state.status_Depositkey1);
      datafrm.append("sumpricereport", this.state.sumpricereport);
      datafrm.append("tel1", this.state.tel1);
      datafrm.append("detel", this.state.detel);
      api.post("lkupdatestatusroommove.php",datafrm,{
       headers: {
                 'content-type': 'multipart/form-data'
                }
                })
                        .then(res => {
                           // console.warn(res);
                           // console.log("response: ", res)
                            if (res.status=== 200) {

                          Swal.fire({
                            title: 'ย้ายห้องสำเร็จ',
                            icon: 'success',
                          // showCancelButton: true,
                            confirmButtonText: 'ตกลง',
                          // cancelButtonText: 'No, keep it'
                          }).then((result) => {
                            this.props.getroom();
                            this.toggle();
                           // this.getwork();
                           // window.location.href = '/'
                          })

                            }else{
                            // window.location.href = '/'
                            }

                        })

            }, 1000);

  }

  
  updatescontinueroom (){
           
    setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id", this.state.id_room);//
      datafrm.append("numberroom", this.state.numberroom);
      datafrm.append("roomset", this.state.roomset);
      datafrm.append("numberroomset", this.state.numberroomset);

      datafrm.append("id_time", this.state.id_time);
      datafrm.append("Depositkey", this.state.Depositkey);
      datafrm.append("Differences", this.state.Differences);
      datafrm.append("pic_idcard", this.state.pic_idcard);
      datafrm.append("price", this.state.price);
      datafrm.append("roommove", this.state.roommove);
      datafrm.append("status", this.state.status);
      datafrm.append("status_Depositkey", this.state.status_Depositkey);
      datafrm.append("sumprice", this.state.sumprice);
      datafrm.append("tel", this.state.tel);
      datafrm.append("temporary", this.state.temporary);
      datafrm.append("timeend", this.state.timeend);
      datafrm.append("timestart", this.state.timestart);

      datafrm.append("Depositkey1", this.state.Depositkey1);
      datafrm.append("endtimereport", this.state.endtimereport);
      datafrm.append("id_memberreport", this.state.id_memberreport);
      datafrm.append("id_reportlist", this.state.id_reportlist);
      datafrm.append("numberroommove", this.state.numberroommove);
      datafrm.append("starttimereport", this.state.starttimereport);
      datafrm.append("status1", this.state.status1);
      datafrm.append("status_Depositkey1", this.state.status_Depositkey1);
      datafrm.append("sumpricereport", this.state.sumpricereport);
      datafrm.append("tel1", this.state.tel1);
      datafrm.append("detel", this.state.detel);
      api.post("lksavestaycontinue.php",datafrm,{
       headers: {
                 'content-type': 'multipart/form-data'
                }
                })
                        .then(res => {
                           // console.warn(res);
                           // console.log("response: ", res)
                            if (res.status=== 200) {

                          Swal.fire({
                            title: 'ต่อห้องสำเร็จ',
                            icon: 'success',
                          // showCancelButton: true,
                            confirmButtonText: 'ตกลง',
                          // cancelButtonText: 'No, keep it'
                          }).then((result) => {
                            this.props.getroom();
                            this.toggle();
                           // this.getwork();
                           // window.location.href = '/'
                          })

                            }else{
                            // window.location.href = '/'
                            }

                        })

            }, 1000);

  }


  updateDepositkey (){
           
    setTimeout(() => {
      const n = Number(this.state.sumprice);
      const sumpricetoup =n+100 ;

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id", this.state.id_room);//
      datafrm.append("numberroom", this.state.numberroom);//
      datafrm.append("Depositkey", "100"); //ss
      datafrm.append("status_Depositkey", "1"); //ss
      datafrm.append("sumprice", sumpricetoup); //ss
     

      datafrm.append("Depositkey1", "100");//
      datafrm.append("id_memberreport", this.state.id_memberreport);//
      datafrm.append("id_reportlist", this.state.id_reportlist);//
      datafrm.append("status_Depositkey1", "1");//
      datafrm.append("sumpricereport", sumpricetoup);//
   
      api.post("lkupdateDepositkey.php",datafrm,{
       headers: {
                 'content-type': 'multipart/form-data'
                }
                })
                        .then(res => {
                           // console.warn(res);
                           // console.log("response: ", res)
                            if (res.status=== 200) {

                          Swal.fire({
                            title: 'มัดจำกุญแจสำเร็จ',
                            icon: 'success',
                          // showCancelButton: true,
                            confirmButtonText: 'ตกลง',
                          // cancelButtonText: 'No, keep it'
                          }).then((result) => {
                            this.props.getroom();
                            this.toggle();
                           // this.getwork();
                           // window.location.href = '/'
                          })

                            }else{
                            // window.location.href = '/'
                            }

                        })

            }, 500);

  }


  render() {
     console.log(this.state.roomset)
    console.log(this.state.numberroomset)
    return (
      <MDBContainer>
        <MDBBtn color="dark" onClick={this.toggle}><MDBIcon icon="chalkboard-teacher" /> จัดการ</MDBBtn>
        <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
          <MDBModalHeader toggle={this.toggle}>จัดการห้อง </MDBModalHeader>

          <MDBModalBody>

          <h3>ห้องที่ {this.props.numberroom}</h3> 

         
          <MDBRow>
          <MDBCol sm="4"> <MDBBtn color="deep-purple" onClick={this.updatestatusopenroom}><MDBIcon icon="bed" /> เปิดใช้ห้อง</MDBBtn></MDBCol>
          <MDBCol sm="4"> <MDBBtn color="unique" onClick={this.updatemoveroom}><MDBIcon icon="bed" /> ย้ายห้อง</MDBBtn></MDBCol>
          <MDBCol sm="4"> <MDBBtn color="cyan" onClick={this.updatescontinueroom}><MDBIcon icon="bed" /> ต่อห้อง</MDBBtn></MDBCol>
         </MDBRow>
         <MDBRow>
         <MDBCol sm="4"></MDBCol>
         <MDBCol sm="4">
        {this.state.Depositkey === "100" ?<>
       <MDBBadge color="success">มัดจำกุญแจแล้ว</MDBBadge>
        </>:<>
         <MDBBtn color="dark-green" onClick={this.updateDepositkey}><MDBIcon icon="key" /> มัดจำกุญแจ</MDBBtn>
        
        </>}

         </MDBCol>
         <MDBCol sm="4"></MDBCol>
         </MDBRow>

         {this.state.move === true ?<>
         <p>sds</p>
                <select className="browser-default custom-select" onChange={this.handleChange}>
                   <option>------กรุณาเลือกห้องที่ต้องการย้ายไป------</option>
                   {this.state.room.map((room,index )  => 
                   <option value={room.id_room}>ห้องที่ {room.numberroom}</option>
                   )}
                </select>
                <p>sds</p>
                <input className="form-control" onChange={this.onTextChange} name="detel"
                      value={this.state.detel} placeholder="สาเหตุ"  />
        <br/>
        <br/>
        <div className="d-flex flex-wrap justify-content-center">
            <MDBCol sm="6"> <MDBBtn color="mdb-color"  onClick={this.updatestatusmoveroom}><MDBIcon icon="bed" /> ยืนยันย้ายห้อง</MDBBtn></MDBCol>
        </div>
           
         </>:<></>}

    
          </MDBModalBody>

          <MDBModalFooter>
            <MDBBtn color="secondary" size="sm" onClick={this.toggle}>ปิด</MDBBtn>
            {/* <MDBBtn color="primary" size="sm">Save changes</MDBBtn> */}
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    )
  }
}
